
import React from "react";
import homeBannerGif from '../../assets/gifs/headervideo.gif'; // Update this with your actual GIF path
import vector from '../../assets/Vector.png';
import { useNavigate } from "react-router-dom";
import header from '../../assets/WhatWeDo/header.png'
import styled from "styled-components";
import "../Sections/Header.css";


export default function Header() {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className="" style={{ backgroundColor: '#d5d0ef' }}> */}
      <div className="bg-cover bg_purple custom-padding  px-5 py-4 px-2 pb-5 4 m-0 p-0 bg-center d-flex align-items-start justify-content-start  "
      >
        <div className="row align-items-start justify-content-between  mt-sm-4 m-0 p-0  row-padding"
          style={{
            // backgroundColor: '#5A8C75',
            backgroundImage: `url(${header})`,
            backgroundSize: 'cover',
            // backgroundPosition: 'center center',  // This ensures the image starts from the top
            backgroundRepeat: 'no-repeat',

          }}
        >

          {/* Left side text content */}
          <div className="col-12 col-md-6 mb-4 my-sm-3 pl-sm-5  pr-2 p-0  padding-col">

              <div className="d-sm-block d-none custom-height" ></div>
              <div className="d-sm-block d-none  " ></div>

              <h3 className="pb-2 font-weight-500 ml-1  pl-sm-2 pl-lg-2 custom-title " >
              Empowering Businesses, <br />Through Driven People
              </h3>

              <div className="d-sm-block d-none custom-height1" ></div>
              <div className="d-sm-block " style={{ height: 10 }}></div>

              <p className=" mr-sm-5  ml-1 pl-sm-2 pl-lg-2 custom-parag" style={{}}>
              At Talent Expertz HR Solutions, we find driven talent and connect them to the opportunities with a people-first approach, aiming to create an impact and make a difference.
              </p>

              <div className="d-sm-block d-none custom-height2" ></div>
              <div className="d-sm-block  " style={{ height: 10 }}></div>

              <div className="d-flex flex-column ml-1 btn-left flex-md-row align-items-start align-items-lg-start justify-content-between mt-2"
             >
                {/* FOR JOB SEEKERS Section */}
                <div className="col-md-4 mb-2 mt-4  custom-left mb-lg-2 mb-md-0 p-0 mr-sm-2 pl-sm-2 pl-lg-2  align-items-start align-items-lg-start">
                  <h2 className="pb-2 custom-subtitle" style={{ marginBottom :"1.7rem" }}>
                    FOR JOB SEEKERS
                  </h2>
                  <button
                    className="btn  btn-job-seeker mb-3 " style={{ fontFamily: 'Inter, sans-serif' }}
                    onClick={() => navigate('/Career')}
                  >
                    Find your next jobs
                  </button>
                </div>

                {/* Vertical Line */}
                <div className="col-md-1 d-flex justify-content-start mr-1 mt-2 mb-2 custom-hr p-0">
                  <div
                    className="custom-border-right d-none d-md-block"
                    style={{
                      width: '2px',
                      backgroundColor: '#160A54',
                      alignSelf: 'center', // Centers the line vertically within the column
                      height: '157px', // Adjust height as needed
                    }}
                  ></div>

                </div>

                {/* FOR BUSINESS Section */}
                <div className="col-md-7  mb-2 mt-4 custom-left mb-lg-2 mb-2 mb-md-0 p-0 ml-sm-2 "
                >
                  <h2 className=" pb-2  custom-subtitle" style={{ paddingLeft:"6px",marginBottom :"1.7rem",fontFamily: 'Barlow, sans-serif', fontSize: '28px', color: '#160A54', fontWeight: '500' }}>
                    FOR BUSINESS 
                  </h2>
                  <div className="d-flex flex-row flex-wrap" style={{paddingLeft:"6px",}}>
                    <button
                      className="btn btn-custom  mb-2"
                      style={{ fontFamily: 'Open Sans, sans-serif', }}
                      onClick={() => navigate('/Contact')}
                    >
                      Preview candidates
                    </button>

                    <button
                      className="btn btn-custom mb-2  "
                      style={{ fontFamily: 'Open Sans, sans-serif', }}
                      onClick={() => navigate('/Contact')}
                    >
                      Hire now
                    </button>
                  </div>
                </div>
              </div>


          </div>


          {/* Right side GIF with responsive background and rounded corners */}
          <div className="col-12 col-md-6 p-0 mt-1 position-relative order-1  order-md-2 custom-order-sm-first order-sm-first mb-4 mb-md-0 d-block ">
            {/* Background vector image positioned at the top left, outside the wrapping div */}
            <div 
            className="vector-size"
              style={{
                position: 'absolute',
                // top: '-19px', 
                // left: '-13px', 
                top: '-27px', 
                left: '-21px', 
                backgroundImage: `url(${vector})`,
                backgroundSize: 'contain', // Adjust as needed
                backgroundRepeat: 'no-repeat', // Prevent repeating the image
                // width: '140px',
                // height: '140px',
                width: '191px',
                height: '220px',
                zIndex: 3,
              }}
            ></div>

            {/* Wrapping div for stacking */}
            <div className="position-relative ml-2"
              style={{ position: 'relative', width: '100%', height: '100%' }}>
              {/* Background color div with shadow effect */}
              <div
              className="bgset"
                style={{
                  position: 'absolute',
                  // borderRadius: '78px',
                  borderRadius: '105px',
                  marginTop: '12.2px',
                  marginLeft: '9px',
                  backgroundColor: '#837bad',
                  // width: '87%',
                  height: '100%',
                  // width: '93.9%',
                  // maxWidth: "93.9%",
                  width: '92.5%',
                  maxWidth: "100%",
                  zIndex: 1,
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', // Adds a subtle shadow

                }}
              ></div>

              {/* GIF positioned on top of the background */}
              <div className="position-relative" style={{ zIndex: 2 }}>

                <img
                  src={homeBannerGif}
                  alt="Header GIF"
                  className="img-fluid"
                  style={{
                    // borderRadius: '78px',
                    borderRadius: '105px',
                    // width: '100%',
                    // maxWidth: "93.5%",
                    marginTop: '0px',
                    // height: '99%', // Set to fill the container
                    // maxHeight: '98%', // Ensure it won't exceed this height
                  }}
                />
              </div>
            </div>
          </div>

        </div>
      </div>


     
    </>
  );
}
